import React, { useCallback } from "react";
import { auth } from "firebase/app";
import { RouteComponentProps } from "react-router-dom";
import { Formik } from "formik";
import { toastr } from "react-redux-toastr";
import { Box, Button, Flex, Text } from "rebass";
import { MdNavigateBefore } from "react-icons/md";

import { FormComponent } from "./FormComponent";
import { SuccessMessage } from "./SuccessMessage";
import { FormActionTypes, initialValues, validationSchema, ValueTypes } from "./formSettings";

export const SendPasswordResetEmailForm: React.FC<RouteComponentProps> = ({ history }) => {
  const handleOnSubmit = useCallback((values: ValueTypes, actions: FormActionTypes) => {
    const { email } = values;

    auth().sendPasswordResetEmail(email)
      .then(() => {
        actions.setStatus(email);
        toastr.success("Reset Password", `reset password link send to ${email}`);
      })
      .catch(({ message }) => {
        toastr.error("Reset Password", message);
      })
      .finally(() => {
        actions.setSubmitting(false);
      })
  }, []);

  return (
    <Flex
      height="100%"
      flexDirection="column"
      p="65px 100px 35px"
    >
      <Flex color="#2b3160">
        <Button
          px="0"
          py="0"
          mr="15px"
          borderRadius="50%"
          color="inherit"
          bg="hoki-25"
          onClick={history.goBack}
        >
          <MdNavigateBefore size={32} display="block" />
        </Button>

        <Text
          as="h3"
          fontSize="30px"
          fontWeight="bold"
          lineHeight="1.07"
        >
          Send Reset Link
        </Text>
      </Flex>

      <Box mt="40px">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleOnSubmit}
          render={(props) => props.status
            ? <SuccessMessage email={props.status} />
            : <FormComponent {...props} />
          }
          enableReinitialize
        />
      </Box>
    </Flex>
  );
};
